import React, { useEffect, useMemo } from 'react';
import styles from './catalogPage.module.css';
import { Header } from '../../components/Header/Header';
import catalogIcon from '../../assets/catalog-icon.svg';
import { Slider } from '../../components/Slider/Slider';
import { CatalogCard } from '../../components/CatalogCard/CatalogCard';
import { CatalogSliderCard } from '../../components/Slider/CatalogSliderCard/catalogSliderCard';
import { FooterBtn } from '../../UI/FooterBtn/FooterBtn';
import supportIcon from '../../assets/support-icon.svg';
import { useAllItemsQuery } from '../../store/api/item.api';

export const CatalogPage = () => {

	const schema = window.sessionStorage.getItem('schema') || '';
	const { data: itemsData = [], isLoading } = useAllItemsQuery({ schema });

	const getActualPrice = item => item.price_disc_sub ?? item.price_disc ?? item.price;
	const getActualPriceSharing = item => item.P2_price_disc ?? item.P2_price;

	const sliderImgs = useMemo(() => {
		if (!itemsData.length) return { distrib: null, under500: null, under1000: null, russianLang: null };

		const usedImgs = new Set();
		let distrib = null, under500 = null, under1000 = null, russianLang = null;

		for (const item of itemsData) {
			const price = getActualPrice(item) || getActualPriceSharing(item);
			const img = item.img;
			if (!img || usedImgs.has(img)) continue;

			if (!distrib && (item.price_disc || item.P2_price_disc)) distrib = img;
			else if (!under500 && price <= 500) under500 = img;
			else if (!under1000 && price <= 1000) under1000 = img;
			else if (!russianLang && item.lang === 'Полностью на русском') russianLang = img;

			usedImgs.add(img);
		}

		return { distrib, under500, under1000, russianLang };
	}, [itemsData]);

	const uniqueGenresWithImg = useMemo(() => {
		if (!itemsData.length) return [];

		const map = new Map();

		for (const item of itemsData) {
			let title;
			if (schema === '') {
				if (!item.genres) continue;
				for (const genre of item.genres) {
					title = genre.title;
					if (!map.has(title)) map.set(title, []);
					const arr = map.get(title);
					if (arr.length < 10) arr.push(item.img);
				}
			} else {
				title = item?.regions?.title;
				if (schema === 'PS_sharing' || schema === 'services') title = item?.categories?.[0]?.title;
				if (title) {
					if (!map.has(title)) map.set(title, []);
					const arr = map.get(title);
					if (arr.length < 10) arr.push(item.img);
				}
			}
		}

		return Array.from(map.entries()).map(([genre, imgs]) => ({
			genre,
			img: imgs[Math.floor(Math.random() * imgs.length)],
		}));
	}, [itemsData, schema]);

	return (
		<div className="main">
			<Header />
			<div className={styles.header}>
				<div className={styles.title_block}>
					<img src={catalogIcon} alt="catalogIcon" />
					<h2>Каталог</h2>
				</div>
			</div>

			{(schema === '' || schema === 'PS_sharing') && (
				<Slider type="catalog">
					<CatalogSliderCard title="Распродажа" engTitle="distrib" disc img={sliderImgs.distrib} />
					<CatalogSliderCard title="До 500" engTitle="under500" img={sliderImgs.under500} />
					<CatalogSliderCard title="До 1000" engTitle="under1000" img={sliderImgs.under1000} />
					<CatalogSliderCard title="Полностью на русском" engTitle="russianLang" img={sliderImgs.russianLang} />
				</Slider>
			)}

			<div className="result_container">
				{
					uniqueGenresWithImg?.map(({ genre, img }) => (
						<CatalogCard key={genre} genre={genre} img={img} />
					))
				}
			</div>

			<div className={styles.footer}>
				<FooterBtn
					title="Support"
					img={supportIcon}
					description="На всякий случай, если у вас будут вопросы"
					url="https://t.me/eazysupp"
				/>
			</div>
		</div>
	);
};
